import { useTranslation } from "react-i18next";
import { Machine } from "@/machines/types/machine.ts";
import { useUpdateMachineSettings } from "@/machines/api/queries/machines.queries.ts";
import MachineSettingsForm from "./machine-settings-form";
import toast from "react-hot-toast";

interface MachineSettingsFormHandlerProps {
  machine: Machine;
}

const MachineSettingsFormHandler = ({ machine }: MachineSettingsFormHandlerProps) => {
  const { t } = useTranslation("machines");
  const updateSettings = useUpdateMachineSettings();

  const handleSubmit = async (data: typeof machine) => {
    try {
      await updateSettings.mutateAsync({
        id: machine.id,
        settings: {
          name: data.name,
          make: data.make,
          model: data.model,
          bucket_width_mm: data.bucket_width_mm,
          loading_time_target_s: data.loading_time_target_s,
          waiting_time_target_s: data.waiting_time_target_s,
          buckets_per_truck_target: data.buckets_per_truck_target,
        },
      });
      toast.success(t("settingsForm.toast.success"));
    } catch (error) {
      console.error("Failed to update machine settings:", error);
      toast.error(t("settingsForm.toast.error"));
      throw error;
    }
  };

  return (
    <MachineSettingsForm
      machine={machine}
      onSubmit={handleSubmit}
      isLoading={updateSettings.isPending}
    />
  );
};

export default MachineSettingsFormHandler;
